import React, { useCallback, useEffect, useState } from "react";
import DocumentRender from "../commonfields/shared/DocumentRender";
import "./pages.scss";
import { getSidebarIcon } from "../config/SideBarConfig";
import TextInput from "../commonfields/inputs/TextInput";
import { ReactComponent as SearchIcon } from "../images/search-icon.svg";
import { ReactComponent as BackIcon } from "../images/back-icon.svg";
import { ReactComponent as DocUploadIcon } from "../images/doc-upload-icon.svg";
import { ReactComponent as ExtractedIcon } from "../images/extracted-icon.svg";
import { ReactComponent as SyncIcon } from "../images/sync-icon.svg";
import { ReactComponent as CheckIcon } from "../images/diable-check.svg";
import { ReactComponent as GreenCheckIcon } from "../images/greencheck.svg";
import {
  DocumentStatusEnum,
  IDocumentModel,
} from "../tsmodels/QuestionnaireModel";
import { RoutesEnum, SidebarEnum } from "../tsmodels/RoutesModel";
import { IDropdownOptionsModel } from "../tsmodels/SharedModel";
import { useNavigate, useParams } from "react-router-dom";
import DropdownInput from "../commonfields/inputs/DropdownInput";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Button,
} from "reactstrap";
import DynamicForm from "../components/mappingFields/DynamicForm";
import { AxiosError } from "axios";
import { catchError } from "../utils/Utils";
import Appservice from "../services/appservice";
import {
  getDocumentDetailsSections,
  getDocumentFieldsMappingSections,
  getImageDataSections,
} from "../helpers/ServiceSections";

interface IDocumentDataProps {}
const DocumentsDetailsPage = (props: IDocumentDataProps) => {
  //
  const { documentId } = useParams();
  const navigate = useNavigate();
  const service = new Appservice();

  // states
  const [documentDetails, setDocumentDetails] =
    useState<IDocumentModel | null>();
  const [documentSearch, setDocumentSearch] = useState("");
  const [images, setImages] = useState<any>([]);
  const [fields, setFields] = useState<any>({});
  const [fieldsData, setFieldsData] = useState<any>([]);
  const [loader, setLoader] = useState<boolean>(false);
  const [open, setOpen] = useState<any>("");
  const [questionnaireMap, setQuestionnaireMap] = useState<
    IDropdownOptionsModel[]
  >([]);

  // temp states
  const [selectedPage, setSelectedPage] = useState<any>();
  const [selectedField, setSelectedField] = useState<any>();
  const [isVerifyAll, setIsVerifyAll] = useState<boolean>(false);

  // funcs - helpers
  const toggleAccordian = (id: any) => {
    if (open === id) {
      setOpen("");
    } else {
      setOpen(id);
    }
    // setOpen({...open, [id]:!open[id]});
  };


  const formatData = (data: any, status?: DocumentStatusEnum) => {
    const result: any = {};
    data?.forEach((d: any) => {
      if (d?.section && ((status ?? documentDetails?.documentStatus) === DocumentStatusEnum.VERIFIED)) {
        result[d.section] = result[d.section] || [];
        result[d.section].push(d);
      } else {
        result["default"] = result["default"] || [];
        result["default"].push(d);
      }
    });
    setFields(result);
  };

  const handleDocumentSearch = (e: any) => {
    setDocumentSearch(e?.target?.value);
  };

  const onFieldClick = (field: any) => {
    if (field) {
      setSelectedField(field);
      field?.page && setSelectedPage(field?.page);
    }
  };

  const removeFieldClick = () => setSelectedField(null);

  const handleRegenerate = () => {
    const payload = {
      documentId,
      status: DocumentStatusEnum.REGENERATE,
    };
    updateDocStatus(
      payload,
      documentDetails?.documentStatus !== DocumentStatusEnum.VERIFIED &&
      documentDetails?.documentStatus !== DocumentStatusEnum.REGENERATE
    );
    setDocumentDetails((prev) => {
      if (prev && prev?.documentId) {
        return { ...prev, documentStatus: DocumentStatusEnum.REGENERATE };
      } else return null;
    });
    removeFieldClick();
  };

  const saveExtraction = () => {
    const payload = {
      documentId,
      status: DocumentStatusEnum.VERIFIED,
    };
    updateDocStatus(payload);
    removeFieldClick();
  };

  // funcs - redirects
  const goBack = () => navigate(`/${RoutesEnum.DOCUMENTS}`);

  // funcs - apis
  const getDocumentDetails = (documentId: string, getImages = false) => {
    const payLoad = {
      ...getDocumentDetailsSections,
      documentId,
    };
    setLoader(true);
    service
      .getApiData(payLoad)
      .then((res: any) => {
        if (res?.data && res?.data?.[0]) {
          setDocumentDetails(res?.data?.[0]);
          getImages && getImageData(documentId);
          if (res?.data?.[0]?.documentStatus !== DocumentStatusEnum.INITIAL) {
            getDocumentFieldsMapping(
              documentId,
              res?.data?.[0]?.documentStatus
            );
          }
        }
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
      });
  };

  const getImageData = (documentId: string) => {
    const payLoad = {
      ...getImageDataSections,
      documentId,
    };
    setLoader(true);
    service
      .getApiData(payLoad)
      .then((res: any) => {
        if (res?.data && res?.data?.length > 0) {
          const images = res?.data?.map((i: any) => {
            if (i.image_size) {
              i.image_size = JSON.parse(
                i.image_size
                  .replaceAll('"', "'")
                  .replace("height", '"height"')
                  .replace("width", '"width"')
              );
            }
            return i;
          });
          setImages(images || []);
          saveExtraction();
        } else return setImages([]);
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const getDocumentFieldsMapping = (
    documentId: string,
    status?: DocumentStatusEnum
  ) => {
    const payLoad = {
      ...getDocumentFieldsMappingSections,
      isRead:
        (status ?? documentDetails?.documentStatus) ===
        DocumentStatusEnum.VERIFIED
          ? true
          : false,
      documentId,
    };
    setLoader(true);
    service
      .getApiData(payLoad)
      .then((res: any) => {
        if (res?.data && res?.data?.length > 0) {
          const fields = res?.data
          ?.sort((a: any, b: any) =>a?.page-b?.page)
          ?.sort((a1: any, b1: any) =>a1?.sequenceNumber-b1?.sequenceNumber)
          ?.map((f: any) => {
            if (f.coordinates) {
              f.coordinates = JSON.parse(
                f.coordinates
                  .replaceAll('"', "'")
                  .replace("h", '"h"')
                  .replace("w", '"w"')
                  .replace("x", '"x"')
                  .replace("y", '"y"')
              );
            }
            return f;
          });
          formatData(fields || [], status);
          setFieldsData(fields || []);
        }
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const getQuestionsList = async () => {
    const payLoad = {
      sections: "getDocExtractedFields",
      screen: "QuestionarieScreen",
      documentId: documentId,
      isJsonReturnObject: true,
      isJsonQuery: true,
    };
    setLoader(true);
    await service
      .getQuestionsList(payLoad)
      .then((res: any) => {
        if (res.data && res.data.length) {
          res.data[0].fields = res.data[0].fields || [];
          res.data[0].fields = res.data[0].fields.map((f: any) => {
            if (f.coordinates) {
              f.coordinates = JSON.parse(
                f.coordinates
                  .replaceAll('"', "'")
                  .replace("h", '"h"')
                  .replace("w", '"w"')
                  .replace("x", '"x"')
                  .replace("y", '"y"')
              );
            }
            return f;
          });
        }

        // setImages(res?.data[0]?.images);
        // setDocumentDetails(res?.data?.[0]);
        formatData(res?.data?.[0]?.fields);
        setFieldsData(res?.data?.[0]?.fields);
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const handleVerfiedAll = (verify: boolean) => {
    setLoader(true);
    service
      .saveverifyAllDocFields(documentId, verify)
      .then((res: any) => {
        setIsVerifyAll(verify);
        // const result: any = {};
        // for (const key in fields) {
        //   result[key] = fields[key]?.map((f: any) => (f.verified = verify));
        // }
        // setFields(result);
        documentId &&
          getDocumentFieldsMapping(documentId, documentDetails?.documentStatus);
      })

      .catch((error: AxiosError) => {
        catchError(error, true);
      })

      .finally(() => {
        setLoader(false);
      });
  };

  const getQuestionnireList = () => {
    const payLoad = {
      sections: "getQuestionarieTypes",
      screen: "QuestionarieScreen",
    };
    setLoader(true);
    service
      .getQuestionsList(payLoad)
      .then((res: any) => {
        const formattedData = res?.data?.map((p: any) => ({
          value: p?.questionarie_id,
          label: p?.name,
          data: p,
        }));
        setQuestionnaireMap(formattedData || []);
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const saveExtreactedFieldMappings = () => {
    setLoader(true);
    service
      .saveExtreactedFieldMappings(documentId)
      .then((res: any) => {})
      .catch((error: AxiosError) => {
        catchError(error, true);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const updateDocStatus = (data: any, apiCall = true) => {
    if (apiCall) {
      setLoader(true);
      service
        .updateDocStatus(data)
        .then((res: any) => {
          if (res?.data && documentId) {
            getDocumentDetails(documentId);
          }
        })
        .catch((error: AxiosError) => {
          catchError(error, true);
          setLoader(false);
        });
    } else {
      documentId && getDocumentFieldsMapping(documentId, data?.status);
    }
  };

  const accInformation = () => {
    <>
    { Object.keys(fields).map((k: string, index: number) =>
      k !== "default" ? (
        <Accordion
          key={index}
          open={open}
          toggle={() => toggleAccordian(k.replaceAll(" ", "@@"))}
        >
          <AccordionItem>
            <AccordionHeader targetId={k.replaceAll(" ", "@@")}>
              {k}
            </AccordionHeader>
            <AccordionBody accordionId={k.replaceAll(" ", "@@")}>
              <DynamicForm
                initialFields={fields?.[k]}
                onFieldClick={onFieldClick}
                selectedField={selectedField}
                group={k}
                loader={loader}
                status={documentDetails?.documentStatus}
              />
            </AccordionBody>
          </AccordionItem>
        </Accordion>
      ) : (
        <></>
      )
    )}</>
  }

  // useEffect
  useEffect(() => {
    getQuestionnireList();
    // getQuestionsList()
  }, []);

  useEffect(() => {
    if (documentId) {
      getDocumentDetails(documentId, true);
    }
  }, [documentId]);

  return (
    <div className="documents-details-page">
      <div className="subheader-container">
        <div className="subheader-left">
          <div className="subheader-icon" onClick={goBack}>
            <BackIcon />
          </div>

          <div className="subheader-title">{decodeURI(documentDetails?.documentName || '')}</div>
        </div>
        <div className="subheader-right">
          <div className="document-mapping">
            <div className="mapping-text">
              <span className="mapping-icon">
                {getSidebarIcon(SidebarEnum.MAPPINGS)}
              </span>
              Map to Questionnaire:
            </div>
            <div className="mapping-questionnire">
              <DropdownInput
                value={questionnaireMap?.find(
                  (each: IDropdownOptionsModel) =>
                    each?.value === documentDetails?.questionnaireId
                )}
                options={questionnaireMap}
                placeholder="Select a Questionnaire"
                // onChange={handleQuestionnaire}
                disabled={true}
              />
            </div>
          </div>
          <div className="document-divider"></div>
          <div className="subheader-input-container">
            <TextInput
              className="subheader-input"
              value={documentSearch}
              onChange={handleDocumentSearch}
              placeholder="Search this document"
            />
            <SearchIcon className="search-icon" />
          </div>
        </div>
      </div>

      <div className="document-details-container">
        <div className="documents-details-left">
          {/* <div className="document-display-container"> */}
          <div className="document-display-header">
            <div className="document-display-left">
              <div className="document-display-icon">
                <DocUploadIcon />
              </div>
              <div className="document-display-text">DOCUMNET UPLOAD</div>
            </div>
            <div className="document-display-right">Add Field Tag</div>
          </div>

          <div className="document-display-image">
            <DocumentRender
              pages={images}
              highlights={fieldsData}
              selectedHighlight={selectedField || null}
              selectedPage={selectedPage || null}
            />
          </div>
          {/* </div> */}
        </div>
        <div className="documents-details-right">
          <div className="extracted-header">
            <div className="extracted-left">
              <ExtractedIcon />
              <div className="extracted-header-title">EXTRACTED FIELDS</div>
            </div>
            <div className="extracted-right">
              <>
                <Button className="regen-btn" onClick={handleRegenerate}>
                  <SyncIcon /> Regenerate
                </Button>

                {(documentDetails?.documentStatus === DocumentStatusEnum.VERIFIED)
                  ? (
                  <Button
                    className="verify-all-btn"
                    onClick={() => {
                      handleVerfiedAll(isVerifyAll ? false : true);
                    }}
                  >
                    {isVerifyAll ? <GreenCheckIcon /> : <CheckIcon />} Verify
                    All
                  </Button>
                ) : (
                  <></>
                )}

                {documentDetails?.documentStatus ===
                DocumentStatusEnum.REGENERATE || (documentDetails?.documentStatus ===
                  DocumentStatusEnum.INITIAL)? (
                  <Button onClick={saveExtraction} className="verify-all-btn">
                    Save All
                  </Button>
                ) : (
                  <></>
                )}
              </>
            </div>
          </div>

          <div className="Form-dy">
            {documentDetails?.documentStatus === DocumentStatusEnum.INITIAL ? (
              <></>
            ) : (
              <>
                {documentDetails?.documentStatus ===
                DocumentStatusEnum.REGENERATE ? (
                  <DynamicForm
                    initialFields={fields["default"]}
                    onFieldClick={onFieldClick}
                    selectedField={selectedField}
                    group="default"
                    loader={loader}
                    status={documentDetails?.documentStatus}
                  />
                ) : (
                  <></>
                )}

                {Object.keys(fields)?.map((k: string, index: number) =>
                  k !== "default" ? (
                    <Accordion
                      key={index}
                      open={open}
                      toggle={() => toggleAccordian(k.replaceAll(" ", "@@"))}
                    >
                      <AccordionItem>
                        <AccordionHeader targetId={k.replaceAll(" ", "@@")}>
                          {k}
                        </AccordionHeader>
                        <AccordionBody accordionId={k.replaceAll(" ", "@@")}>
                          <DynamicForm
                            initialFields={fields?.[k]}
                            onFieldClick={onFieldClick}
                            selectedField={selectedField}
                            group={k}
                            loader={loader}
                            status={documentDetails?.documentStatus}
                          />
                        </AccordionBody>
                      </AccordionItem>
                    </Accordion>
                  ) : (
                    <></>
                  )
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DocumentsDetailsPage;
